module.exports = __webpack_public_path__ + "img/48740351001641.36cd74bf.png";